import React from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

/**
 * Reusable BackButton component for navigation.
 * @param {Object} props
 * @param {string} [props.to="/"] - Target route path
 * @param {string} [props.text="Back to Home"] - Button text
 * @param {string} [props.className=""] - Additional container CSS classes
 * @param {Object} [props.style={}] - Additional inline styles
 */
const BackButton = ({
  to = "/",
  text = "Back to Home",
  className = "",
  style = {},
}) => {
  return (
    <Link to={to} className={`back-home-btn ${className}`} style={style}>
      <FaArrowLeft /> {text}
    </Link>
  );
};

export default BackButton;
